import centroid from "@turf/centroid";
import type { Geometry } from "react-migration/domains/sites/typings/Geometry";
import { calculateZoomLevel } from "react-migration/lib/util/calculateZoomLevel";
import { isVue } from "react-migration/lib/util/isVue";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";
import { SearchAutocompleteSection } from "./types";
import { mapStore } from "src/js/stores/map/store";

function isAddressSearchCoords(props: unknown): props is { lat: number; lng: number } {
  return (
    typeof props === "object" &&
    props !== null &&
    "lat" in props &&
    "lng" in props &&
    typeof (props as { lat: unknown }).lat === "number" &&
    typeof (props as { lng: unknown }).lng === "number"
  );
}

export function getMapCoordinatesForNavigation(
  section: SearchAutocompleteSection,
  eventProperties: void | Record<string, unknown>
): { z: number; lat: number; lng: number } | null {
  if (section.id === "adressess" && isAddressSearchCoords(eventProperties)) {
    return { z: 17, lat: eventProperties.lat, lng: eventProperties.lng };
  }

  const feature = mapStore.selection?.feature;
  const geometry = feature?.geometry;
  if (feature && geometry) {
    const c = centroid(feature);
    if (!c.geometry) return null;
    const [lng, lat] = c.geometry.coordinates;
    const z = Math.min(20, Math.max(1, calculateZoomLevel(geometry as Geometry) + 1));
    return { z, lat, lng };
  }

  return null;
}

export function navigateToMap(
  coords: { z: number; lat: number; lng: number } | null,
  navigateReact: (path: string) => void
) {
  if (coords) {
    const { z, lat, lng } = coords;
    if (isVue()) {
      router.push({
        name: ROUTES.MAP,
        params: { z: String(z), x: String(lat), y: String(lng) },
      });
    } else {
      navigateReact(`/map/explore/${z}/${lat}/${lng}`);
    }
  } else if (isVue()) {
    router.push({ name: ROUTES.MAP });
  } else {
    navigateReact("/map");
  }
}
